import { Box, Icon, Text } from '@nimbus-ds/components';
import { CheckCircleIcon } from '@nimbus-ds/icons';
import useTranslationShipping from 'domains/Shipping/useTranslationShipping';

function NuvemEnvioNationalMethodDescription() {
  const t = useTranslationShipping();

  return (
    <Box
      width="100%"
      display="grid"
      gridTemplateColumns={{ xs: '1fr', md: '1fr 1fr' }}
      gap="4"
      mt={{ xs: '4', md: '4' }}
    >
      <Box display="flex" gap="4" flexDirection="column">
        <Box display="flex" gap="2">
          <Icon source={<CheckCircleIcon />} />
          <Text>
            {t(
              'deliveryMethods.activeShippingMethods.nuvem-envio.texts.item-1',
            )}
          </Text>
        </Box>
        <Box display="flex" gap="2">
          <Icon source={<CheckCircleIcon />} />
          <Text>
            {t(
              'deliveryMethods.activeShippingMethods.nuvem-envio.texts.item-2',
            )}
          </Text>
        </Box>
      </Box>

      <Box display="flex" gap="4" flexDirection="column">
        <Box display="flex" gap="2">
          <Icon source={<CheckCircleIcon />} />
          <Text>
            {t(
              'deliveryMethods.activeShippingMethods.nuvem-envio.texts.item-3',
            )}
          </Text>
        </Box>
        <Box display="flex" gap="2">
          <Icon source={<CheckCircleIcon />} />
          <Text>
            {t(
              'deliveryMethods.activeShippingMethods.nuvem-envio.texts.item-4',
            )}
          </Text>
        </Box>
      </Box>
    </Box>
  );
}

export default NuvemEnvioNationalMethodDescription;
